import { render, staticRenderFns } from "./EventDisplay.vue?vue&type=template&id=59524c39"
import script from "./EventDisplay.vue?vue&type=script&lang=js"
export * from "./EventDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports